module.exports = __webpack_public_path__ + "static/media/rishika_content.7be0faf2.jpg";